import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject }           from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { CommonService, ServiceWalkInService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';

@Component({
    selector: 'add-bill-entry-tab',
    templateUrl: './addBillEntry.component.html'
})
export class AddBillEntryComponent implements OnInit {
    private searchTerms = new Subject<string>();
    isLoadMask: Promise<any>;
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    loadingIndicator: boolean = true;
    @Input() set params(val: any[]) {

        this._params = val;
        this.setPageData();
    }
    // @Input() set clientSearchEmit(val: any[]) {
    //     debugger;
    // }

    statusCusCtrl: FormControl;
    serialNoCtrl: FormControl;
    potCusCtrl: FormControl;
    clientCtrl: FormControl;
    referenceCtrl: FormControl;
    minDate: any;
    branchList: any[] = [];

    locationCtrl: FormControl;
    potCusOptList: any[];
    statusList: any[];
    clientList: any[];
    prodList: any[];
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    paymentFilterList : any[];
    salesBillentryDetails = [];
    columns = [];
    filteredBranch: Observable<any[]>;
    filteredItems: Observable<any[]>;
    filteredSrc: Observable<any[]>;
    filteredReference: Observable<any[]>;
    @Input() servicegriddata: ServiceWalkInModel[] = [];
    @Input() serviceInData: ServiceWalkInModel[] = [];
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('prodAutoComp') prodAutoComp;
    // @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('discountComponent') discountComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    srclistCtrl: FormControl;
    srcList: any[] = [];

    constructor(public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private serviceWalkInService: ServiceWalkInService, public subscribeService: SubscribeService
    ) {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        this.serialNoCtrl = new FormControl();
        this.potCusOptList = ['Yes', 'No'];
        this.statusList = ['Yes', 'No'];
        this.paymentFilterList = ['CASH','CARD','CASH&CARD'];

        function hasSrc(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidSRC: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }

        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        this.srclistCtrl = new FormControl();
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());

        this.srclistCtrl = new FormControl('', [
                Validators.required,
                hasSrc.bind(this)
            ]);
    }

    ngOnInit(): void {
        let that = this;
        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList = res;
                return;
            }
            // this.branchList = res.data;
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' });

        });
        let data = {
            name: ''
        };
        this.commonService
        .getBankLedger(data)
        .then(function (res: any) {
            that.srcList = res['data'];
            // that.actSerialNoList = res['haModelStockSerial'];
            that.srclistCtrl.setValue(that.serviceInData['bank']);
            //that.srclistCtrl.setValue(that.clientInData['bank_name']);
            //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
        });

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model Name', prop: 'model_name', width: 300, minWidth: 300, maxWidth: 300, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:130,minWidth:130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Rate', prop: 'rate', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Amount', prop: 'service_amount', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
        ];

        if (this._params['mode'] == 'Edit') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.serviceInData['service_date'] = new Date();


            /* this.searchComponent.clientSearchEmit.subscribe(($e) => {


                  that.serviceInData['sale_no'] = $e['sale_no'];
                  that.serviceInData['sale_date'] = $e['sale_date'];
                  that.serviceInData['client_id'] = $e['client_id'];
                  that.serviceInData['client_no'] = $e['client_no'];
                  that.serviceInData['client_name'] = $e['client_name'];
                  that.serviceInData['mobile'] = $e['mobile'];
                  that.serviceInData['item'] = $e['item'];
                  that.serviceInData['quantity'] = $e['quantity'];

                  that.serviceInData['reference'] = $e['reference'];
                  that.serviceInData['reference_by'] = $e['reference_by'];
                  that.prodList = $e['prodRes'];

         });*/
        }
        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
        }



        this.serviceInData['payment'] = 'CASH';
        this.serviceInData['cn_raised'] = false;
        this.serviceInData['random_no'] = this.getRandomInt(1, 500);

        this.discountComponent.discountSelectEmit.subscribe(($e) => {
            that.serviceInData['discount'] = $e['dis_approval_amt'];
            that.calGrossTotal();
        });

        this.discountComponent.discountRemoveEmit.subscribe(() => {
            that.serviceInData['discount'] = 0;
            that.calGrossTotal();
        });
    }

    displayBranch(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }

    filterSrc(bank_name: string) {
        bank_name = _.escapeRegExp(bank_name);
        return this.srcList.filter(ha => (new RegExp(bank_name, 'gi').test(ha.bank)
            || new RegExp(bank_name, 'gi').test(ha.bank_name)));
    }

    displaySrc(item_id: number) {

        if (item_id && this.srcList.length > 0) {
            let fhalist = _.find(this.srcList, { 'bank': item_id }),
                bank_name = fhalist.bank_name;
            this.serviceInData['bank_name'] = bank_name;
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['bank_name'];
        }
        return '';
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'serviceTrack',
                date: moment(this.serviceInData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function(res: any) {
                if (res['success']) {
                    that.serviceInData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit') {
                let tabParams = this._params['tabParams'];
                let data = this._params;
                this.serviceInData = this._params;
                this.serviceInData['auto_no'] = this._params['bill_no'];
                this.serviceInData['date'] = new Date(this._params['date']);
                this.prodList = this._params['prodRes'];//new Date();
                this.serviceInData['service_advance_amount'] = this._params['service_advance_amt'];
                if(this._params['hvoutstaus'])
                {
                    this.serviceInData['hvoutstaus'] ='yes';
                }else {
                    this.serviceInData['hvoutstaus'] ='no';
                }
                if(this._params['ha_id'])
                {
                    this.serviceInData['ha_id'] = this._params['ha_id'];
                }
                else{
                    this.serviceInData['ha_id'] ='';
                }
                this.getModelDetails(data);
                // this.singleClientDetails.loadClient(this.serviceInData['client_id']);
            }
        }
    }
    getModelDetails(data: any): void {
        let params = {
            //bill_id: data.bill_id,
            ser_id: data.ser_id,
            //  sale_bill_id : data.sale_bill_id,
            start: this.page.count,
            limit: this.page.limit,
            // orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };

        let that = this;
        this.serviceWalkInService
            .getModelDetails(params)
            .then(function(res: any) {

                that.page.count = res.totCnt;
                that.salesBillentryDetails = res.data;
                that.calGrossTotal();
                //that.prodList  = res.data2;
            });
    }

    getEditDetails(data: any): void {
        let params = {
            //bill_id: data.bill_id,
            ser_id: data.ser_id,
        };

        // let that = this;
        // this.serviceWalkInService
        //    .getEditDetails(params)
        //     .then(function(res: any) {
        //
        //         that.page.count = res.totCnt;
        //        that.salesBillentryDetails = res.data;
        //     });
    }
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.serviceInData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.serviceInData['random_no'] + '_' + nextEl).focus();
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.serviceInData['sale_no'] = fitem.sale_no;
                this.serviceInData['sale_date'] = fitem.sale_date;
                this.serviceInData['item'] = fitem.item;
                this.serviceInData['quantity'] = fitem.quantity;
                this.serviceInData['client_no'] = fitem.client_no;
                this.serviceInData['client_name'] = fitem.client_name;
                this.serviceInData['mobile'] = fitem.mobile; //ANOTHER FIELD
                this.serviceInData['reference_name'] = fitem.reference_name;
                //  this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
                return fitem['client_no'];
            }
        }
        return '';
    }
    //  for loading the product and qunatity on change function
    displayProd(model_id: any) {
        if (this.prodList != undefined) {
            if (model_id && this.prodList.length > 0) {
                let fitem = _.find(this.prodList, { 'model_id': model_id });
                //TO LOAD CLIENT OBJECT
                return fitem['name'];
            }
        }
        return '';
    }
    onChangeProd(ha: any) {
        let that = this;
        let model_id = ha.model_id;
        let fitem = _.find(this.prodList, { 'model_id': model_id });
        //TO LOAD CLIENT OBJECT
        that.servicegriddata['prod_name'] = fitem['name'];
        that.servicegriddata['quantity'] = fitem['quantity'];

    }
    // end
    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.serviceInData = [];
            this.serviceInData['date'] = new Date();
        }
    }
    /* loadFollowUpStatus(): void {
         let that = this;

         that.commonService
             .getFollowUpStatusList({})
             .then(function(res: any) {
                 that.statusList = res.data;
             });
     }*/
    displayStatusFn(fol_id: any) {
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }


    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['prod_name'];
        }
        return '';
    }
    onDeleteSalesbillentry(row: any): void {
        let that = this,
            mode = this._params['mode'];


        if (mode == 'Edit') {
            this.salesBillentryDetails.splice(this.salesBillentryDetails.indexOf(row), 1);
            this.calGrossTotal();
        } else {
            let params = {
                name: row['prod_name'],
                model_id: row['model_id'],
                ser_id: row.ser_id,
            };

            //  this.salesBillgriddata = [];

            this.serviceWalkInService
                .deleteGridList(params)
                .then(function(res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.salesBillentryDetails.splice(that.salesBillentryDetails.indexOf(row), 1);
                        swal('SUCCESS', res.message, 'success');

                        // that.getServiceWalkInList();


                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }
    addServiceInentry(): void {
        let that = this,
            mode = this._params['mode'];
        //   modelID = this.servicegriddata['model_id'],
        // modelName = this.servicegriddata['prod_name'];




        if (mode == 'Edit') {



            let testDet = Object.assign({}, this.servicegriddata);
            this.salesBillentryDetails.push(testDet);
            this.servicegriddata = [];
            this.servicegriddata['amount'] = 0;
            that.page.count = this.salesBillentryDetails.length;
            that.calGrossTotal();

            //this.serialNoList = [];
        } else if (mode == 'Add') {
            let params = {
                ser_id: this.serviceInData['ser_id'],
                model_id: this.servicegriddata['model_id'],
                name: this.servicegriddata['prod_name'],
                qty: this.servicegriddata['qty'],
                rate: this.servicegriddata['rate'],
                amount: this.servicegriddata['amount']
            };
            this.calGrossTotal();

            let testDet = Object.assign({}, this.servicegriddata);

            this.serviceWalkInService
                .addServiceWalkIn(params)
                .then(function(res: any) {
                    that.isLoading = false;

                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');

                        that.salesBillentryDetails.push(testDet);
                        that.servicegriddata = [];

                        that.page.count = that.salesBillentryDetails.length;

                        that.calGrossTotal();
                        // that.getServiceWalkInList();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                })
        }



    }

    calAmount() {
        let qty = this.servicegriddata['qty'],
            rte = this.servicegriddata['rate'],
            amt = 0;

        if (!_.isEmpty(_.toString(rte))) {
            amt = (qty * rte);
        }
        this.servicegriddata['amount'] = amt;
    }
    calGrossTotal() {
        let grand_total = 0;
        let grossTotal = 0;
        const discount = this.serviceInData['discount'];
        const serviceAdvanceAmount = this.serviceInData['service_advance_amount'];

        for (let i = 0; i < this.salesBillentryDetails.length; i++) {
            let amount = this.salesBillentryDetails[i].service_amount;
            grossTotal += Number(amount);
        }

        if (!_.isEmpty(_.toString(discount))) {
            grand_total = Number(grossTotal) - (discount);
        }
        if (!_.isEmpty(_.toString(serviceAdvanceAmount))) {
            grand_total = Number(grand_total) - (serviceAdvanceAmount);
        }

        this.serviceInData['gross_total'] = grossTotal;
        this.serviceInData['grand_total'] = grand_total;
        // this.calGrantTotal('all');
    }

    onCheckboxChange(event: any) {
        let that = this;
        if(that.serviceInData['cn_raised'] == true) {
            that.serviceInData['discount'] = that.serviceInData['grand_total'];
            that.calGrossTotal();
		} else {
            that.serviceInData['discount'] = 0;
            that.calGrossTotal();
        }
    }
    saveBillEntry() {
        let that = this;
        if (_.isEmpty(_.toString(that.serviceInData['grand_total']))) {
            swal('WARNING', 'Grand Total is Empty');
            return;
        }
        if(that.serviceInData['grand_total'] < 0) {
            swal('WARNING', 'Invalid Grand Total Amount');
            return;
        }
        let cash_amount = this.serviceInData['cash_amt'],
        card_amount = this.serviceInData['card_amt'];
        if (this.serviceInData['payment'] == 'CARD') {
            if(that.serviceInData['bank'] == '' ) {
                swal('WARNING', 'Please select Bank');
                return;
            }
        }

        if (this.serviceInData['payment'] == 'CASH&CARD') {
            let tot = parseFloat(cash_amount) + parseFloat(card_amount);
            
                if (this.serviceInData['grand_total'] == tot) {
                    this.serviceInData['grand_total'] = tot;
                } else {
                    swal('WARNING', ' Amount Does Not Match!!!');
                    return;
                }
                if(that.serviceInData['bank'] == '') {
                    swal('WARNING', 'Please select Bank');
                    return;
                }
           
        }

        if(this.serviceInData['cn_raised'] == true) {
			this.serviceInData['cn_raised'] = true
		} else {
			this.serviceInData['cn_raised'] = false
		}

        let testingDate = moment(this.serviceInData['service_date']).format('YYYY-MM-DD'),
        data = {
            ser_id: this.serviceInData['ser_id'],
            auto_no: this.serviceInData['auto_no'],
            date: testingDate,
            warranty: this.serviceInData['warranty'],
            branch_id: this.serviceInData['to_branch'],
            client_id: this.serviceInData['client_id'],
            client_no: this.serviceInData['client_no'],
            client_name: this.serviceInData['client_name'],
            description: this.serviceInData['description'],
            walk_in_type: this.serviceInData['walk_in_type'],
            discount: this.serviceInData['discount'],
            payment: this.serviceInData['payment'],
            grand_total: this.serviceInData['grand_total'],
            mode: this._params['mode'],
            tabParams: this._params['tabParams'],
            ha_id: this.serviceInData['ha_id'],
            hvoutstaus: this.serviceInData['hvoutstaus'],
            cash_amount,
            card_amount,
            chqno: this.serviceInData['chqno'],
            bank: this.serviceInData['bank'],
            cn_raised: this.serviceInData['cn_raised'],
            salesBillentryDetails: JSON.stringify(this.salesBillentryDetails)
        };
        swal({
            title: 'Are you sure to Generate Bill?',
            text: 'You will not be able to Change this Bill Details Again!!!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Generate Bill!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.serviceWalkInService
                .addBillEntry(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;

                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.subscribeService.subReloadServiceGrid();
                        that.serviceInData = [];
                        that.salesBillentryDetails = [];
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                }).catch(function(error: any) {
                    that.isLoading = false;
                    let res = JSON.parse(error._body);
                    swal('ERROR', res.message, 'error');
                    //console.log(error);
                });

        }, function(dismiss) {

        })
    }
    onSaveSalesbillentry() {
        let a =1;
        let that = this,
            mode = this._params['mode'],
            testingDet = this.salesBillentryDetails.length;

        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Service Details');
            return;
        }


        let testingDate = moment(this.serviceInData['service_date']).format('YYYY-MM-DD'),
            data = {

                ser_id: this.serviceInData['ser_id'],
                auto_no: this.serviceInData['auto_no'],
                warranty: this.serviceInData['warranty'],
                branch_id: this.serviceInData['branch_id'],
                date: testingDate,
                client_id: this.serviceInData['client_id'],
                description: this.serviceInData['description'],
                walk_in_type: this.serviceInData['walk_in_type'],
                discount: this.serviceInData['discount'],
                grand_total: this.serviceInData['grand_total'],
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails)
            };
        this.isLoading = true;

        this.serviceWalkInService
            .addSaveServiceWalkIn(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadServiceGrid();
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];

                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/addBillEntry.component.ts